import { ArrowUp } from "lucide-react";
import { LogoMark } from "./Logo";

const Footer = ({ onNav }) => (
  <footer data-testid="site-footer" className="relative bg-ink border-t border-cream/10 overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-20 pb-10">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10">
        <div>
          <div className="flex items-center gap-4">
            <LogoMark className="w-10 h-10" />
            <p className="font-serif italic text-xl text-gold">Sonic Architecture. Cinematic Worldbuilding.</p>
          </div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-cream/35 mt-6">
            © 2026 Dani Morr — All realms independently built
          </p>
        </div>
        <button
          data-testid="back-to-top-button"
          onClick={() => onNav("top")}
          className="group flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.25em] text-cream/50 hover:text-gold transition-colors duration-300"
        >
          Back to top
          <span className="w-10 h-10 rounded-full border border-cream/20 flex items-center justify-center group-hover:border-gold group-hover:-translate-y-1 transition-all duration-300">
            <ArrowUp size={15} />
          </span>
        </button>
      </div>
    </div>
    <div className="select-none pointer-events-none" aria-hidden="true">
      <p className="font-serif font-light text-stroke-cream text-[18vw] leading-[0.75] text-center translate-y-[12%]">
        DANI MORR
      </p>
    </div>
  </footer>
);

export default Footer;
